/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Dry_Otter_CuddleInputs */

const fr_bold_dry_otter_cuddle = /** @type {(inputs: Bold_Dry_Otter_CuddleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attention`)
};

/**

* @param {Bold_Dry_Otter_CuddleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const bold_dry_otter_cuddle = /** @type {((inputs?: Bold_Dry_Otter_CuddleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Dry_Otter_CuddleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_bold_dry_otter_cuddle(inputs)
});